import { ScheduleConstraintCode } from 'services/api/schedule-configuration';

export const scheduleConstraintLabels: Record<ScheduleConstraintCode, string> = {
  [ScheduleConstraintCode.ROOM_CONFLICT]: 'Двойная занятость кабинета',
  [ScheduleConstraintCode.ROOM_SUBJECTS_CONFLICT]: 'Неподходящий кабинет для предмета',
  [ScheduleConstraintCode.TEACHER_CONFLICT]: 'Двойная занятость учителя',
  [ScheduleConstraintCode.TEACHER_QUALIFICATION_CONFLICT]: 'Несоответствие квалификации учителя',
  [ScheduleConstraintCode.CURRICULUM_CONFLICT]: 'Двойной урок у класса',
  [ScheduleConstraintCode.TEACHER_ROOM_CONFLICT]: 'Предпочтительный кабинет учителя',
  [ScheduleConstraintCode.FIRST_LESSON_GAP_CONFLICT]: 'Окно в начале учебного дня',
  [ScheduleConstraintCode.GAP_BETWEEN_LESSONS_CONFLICT]: 'Окна между уроками',
  [ScheduleConstraintCode.REPEATING_SUBJECT_IN_DAY_CONFLICT]:
    'Повтор предмета в один день (младшая школа)',
  [ScheduleConstraintCode.PHYSICAL_TRAINING_BEFORE_HIGH_MENTAL_LOAD_SUBJECTS_CONFLICT]:
    'Физкультура перед сложными предметами',
  [ScheduleConstraintCode.MORE_THAN_TWO_CONSECUTIVE_HIGH_MENTAL_LOAD_SUBJECTS_CONFLICT]:
    'Более двух сложных предметов подряд',
  [ScheduleConstraintCode.DIFFICULTY_DISTRIBUTION_MODEL]:
    'Распределение учебной нагрузки по дням недели',
  [ScheduleConstraintCode.DAILY_DIFFICULTY_DISTRIBUTION_CONFLICT]:
    'Распределение учебной нагрузки по дням недели',
  [ScheduleConstraintCode.TEACHER_AVAILABILITY_CONFLICT]: 'Нерабочий день для преподавателя',
  [ScheduleConstraintCode.SPLIT_LESSON_CONFLICT]: 'Конфликт подгрупп',
  [ScheduleConstraintCode.SATURDAY_LESSON_PENALTY]: 'Сложные предметы в субботу',
  [ScheduleConstraintCode.REPEATING_SUBJECT_IN_DAY_SOFT_CONFLICT]: 'Повтор предмета в один день',
  [ScheduleConstraintCode.SUBJECT_AREA]: 'Предметы одной предметной области в один день',
  [ScheduleConstraintCode.NON_UNIFORM_LESSONS_DISTRIBUTION]:
    'Равномерное распределение предметов по дням недели',
  [ScheduleConstraintCode.TEACHER_GAPS_CONFLICT]: 'Окна учителей',
  [ScheduleConstraintCode.TEACHER_MIX_CONFLICT]: 'Неравномерная нагрузка учителей',
};
